/**
 * @file private-route.tsx
 * @description Компонент защиты маршрутов, который обеспечивает контроль доступа на основе аутентификации в приложении Task Manager. Управляет доступом к публичным/приватным маршрутам с состояниями загрузки и автоматическими редиректами на страницу входа для неавторизованных пользователей.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['react-router-dom', 'react-redux', '@src/store', '@components/ui']
 * @related-files ['src/routes/generate-routes.tsx', 'src/store/slices/user-slice.ts', 'src/store/slices/menu-slice.ts', 'src/components/ui/loader/loader.component.tsx']
 */

import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@src/store';
import { Loader } from '@components/ui';

interface IPrivateRoute {
    isPublic: boolean;
}

export const PrivateRoute = ({ isPublic = false }: IPrivateRoute) => {
    const { accessToken } = useSelector((state: RootState) => state.userStore);
    const { loading: isMenuLoading } = useSelector((state: RootState) => state.menuStore);
    if (!accessToken && !isMenuLoading) {
        return <Navigate to="/login" />;
    }

    if (!isMenuLoading && (accessToken || isPublic)) {
        return <Outlet />;
    }

    return <Loader />;
};
